import apiClient, { getHeaders } from "./axios-client";

/**
 * getZoneByProfile
 * @returns
 */
export const getUserZoneList = async () => {
  const response = await apiClient.get(`/zone/getZoneByProfile`);
  return response.data;
};

/**
 * getGatByZonekey
 * @returns
 */
export const getGatByZonekey = async () => {
  const headers = getHeaders();
  const response = await apiClient.get(
    `zone/getGatByZonekey?zonekey=${headers["Zone-Key"]}`
  );
  return response.data;
};
